import { Link, type LinkProps } from "react-router-dom";

import { useLocalizedPathname } from "@/hooks/useLocalizedPathname";

type LocalizedLinkProps = LinkProps;

function isAbsoluteUrl(value: string) {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
}

function getLocalizedTo({ localizePath, to }: { localizePath: (pathname: string) => string; to: LinkProps["to"] }): LinkProps["to"] {
  if (typeof to === "string") {
    return localizePath(to);
  }

  if (to?.pathname) {
    return {
      ...to,
      pathname: localizePath(to.pathname),
    };
  }

  return to;
}

// eslint-disable-next-line import/prefer-default-export -- Call sites use named import; default would force a wide refactor. -- TODO(web-app): [NX-11455] convert LocalizedLink to default export and update call sites
export function LocalizedLink({ to, reloadDocument, replace, state, preventScrollReset, relative, ...rest }: LocalizedLinkProps) {
  const localizePath = useLocalizedPathname();

  if (typeof to === "string" && isAbsoluteUrl(to)) {
    return <a href={to} {...rest} />;
  }

  return (
    <Link
      to={getLocalizedTo({ localizePath, to })}
      reloadDocument={reloadDocument}
      replace={replace}
      state={state}
      preventScrollReset={preventScrollReset}
      relative={relative}
      {...rest}
    />
  );
}
